function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var Editor = /*#__PURE__*/function () {
  function Editor(client) {
    _classCallCheck(this, Editor);
    this.client = client;
  }
  return _createClass(Editor, [{
    key: "refresh",
    value: function refresh() {
      var _this = this;
      return this.client.findAll().then(function (listado) {
        return _this.filas = listado;
      });
    }
  }, {
    key: "guardar",
    value: function guardar(item) {
      var _this2 = this;
      return this.client.save(item).then(function () {
        return _this2.refresh();
      });
    }
  }, {
    key: "nuevo",
    value: function nuevo(item) {
      var _this3 = this;
      return this.client.add(item).then(function () {
        return _this3.refresh();
      });
    }
  }]);
}();